import {getNotification} from './notifications';

export {
  reducer,
  getNotificationsEnabledSelector,
  getLastNotificationSelector,
  toggleNotificationsEnabled,
  setNotificationsEnabled,
} from './notifications';

export const apiNotifications = {
  getNotification,
};
